import classNames from "classnames";
import React from "react";
import s from "./delete-notification.module.scss";

const DeleteNotofication = ({ closeToast, handleDelete, message, t, messageNote = null, className = null }) => (
  <div className={classNames(s.wrapper, className || "")}>
    <div className={classNames(s.confirmationText, className ? "journeyConfirm" : "")}>{message}</div>
    {messageNote && <div className={s.note}>{messageNote}</div>}
    <div className={s.confirmationOptions}>
      <button className={`${s.confirm} ${s.btn}`} onClick={handleDelete}>
        {t("touchpoint.DeleteOk")}
      </button>
      <button className={`${s.cancel} ${s.btn}`} onClick={closeToast}>
        {t("touchpoint.DeleteCancel")}
      </button>
    </div>
  </div>
);

export default DeleteNotofication;
